'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_UserDetailsForm(firstName, middleName, lastName) {
  this.tl = null;
  this.tn = null;
  this.tm = null;
  this.tl = firstName;
  this.tn = middleName;
  this.tm = lastName;
}
export { $c_Lapp_data_UserDetailsForm as $c_Lapp_data_UserDetailsForm };
$p = $c_Lapp_data_UserDetailsForm.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_UserDetailsForm;
/** @constructor */
function $h_Lapp_data_UserDetailsForm() {
}
export { $h_Lapp_data_UserDetailsForm as $h_Lapp_data_UserDetailsForm };
$h_Lapp_data_UserDetailsForm.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_UserDetailsForm) && (((this.tl === x$0.tl) && (this.tn === x$0.tn)) && (this.tm === x$0.tm))));
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 3;
});
$p.t = (function() {
  return "UserDetailsForm";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.tl;
      break;
    }
    case 1: {
      return this.tn;
      break;
    }
    case 2: {
      return this.tm;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "firstName";
      break;
    }
    case 1: {
      return "middleName";
      break;
    }
    case 2: {
      return "lastName";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_data_UserDetailsForm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jZ)));
}
export { $isArrayOf_Lapp_data_UserDetailsForm as $isArrayOf_Lapp_data_UserDetailsForm };
var $d_Lapp_data_UserDetailsForm = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_UserDetailsForm, "app.data.UserDetailsForm", ({
  jZ: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_UserDetailsForm as $d_Lapp_data_UserDetailsForm };
//# sourceMappingURL=app.data.-User-Details-Form.js.map
